import { ArrayElement } from '@/api/types/api';
import { IOrder } from '@/api/types/order';
import ProductItemTag from '@/components/Product/ProductItemTag';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';

const ProductActivityTag = ({
  item,
}: {
  item: ArrayElement<IOrder['order_items']> & {
    is_seckill?: number;
    seckill_num?: number;
    display_style?: number;
    product_sale_type?: number;
    product_info?: { activity_style?: { product_item_rules_text?: string } };
  };
}) => {
  const { deviceType } = useContext(ResponsiveContext);
  const t = useTranslations('account.myOrders');
  let type;
  let labelText;
  let labelImage;
  if (item.is_seckill === 1 && item.seckill_num > 0) {
    type = 6;
  } else if (item.cart_id === 0) {
    type = 'extra';
  } else if (item.display_style === 1) {
    type = 'member_only';
  } else {
    type = item.product_sale_type;
  }
  if ([2, 3].includes(item.display_style)) {
    type = 7;
    if (deviceType === EPlatform.WEB) {
      labelText =
        item.product_info.activity_style.product_item_rules_text || t('productInfo.seckill');
    } else {
      labelImage =
        (item.product_info.activity_style as { product_item_image_m?: string })
          .product_item_image_m || '';
      if (!labelImage) {
        labelText =
          item.product_info.activity_style.product_item_rules_text || t('productInfo.seckill');
      }
    }
  }
  return (
    <>
      <ProductItemTag
        type={type}
        labelText={labelText}
        labelImage={labelImage}
        className={`${deviceType === EPlatform.WEB ? 'mb-8' : ''}`}
      />
    </>
  );
};

export default ProductActivityTag;
